import { Routes, Route, useNavigate, useLocation } from "react-router";
import * as Sentry from "@sentry/react";
import Welcome from "./routes/welcome";
import WelcomeConnexion from "./routes/welcome.connexion";
import WelcomeLoginRedirect from "./routes/welcome.login-redirect";
import { refreshUser, useMostFreshUser } from "./utils/use-most-fresh-user";
import { ReactElement, useEffect, useRef } from "react";
import { isUserOnboarded } from "./utils/onboarding";
import WelcomeLoginProfile from "./routes/welcome.login-profile";
import QRCode from "./routes/qrcode";
import FromQRCode from "./routes/from_qrcode";
import CGUS from "./routes/cgus";
import PrivacyPolicy from "./routes/confidentialité";
import HomeLayout from "./routes/home.layout";
import Feed from "./routes/feed";
import Users from "./routes/users";
import Profile from "./routes/profile.$id";
import type {
  /* Notification, */ NotificationResponse,
} from "./types/expo-notifications";
import Post from "./routes/post.$postId";
import useMedspotStore from "./zustand/store";
import Stats from "./routes/stats";

const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

function App() {
  const navigate = useNavigate();
  const setIsDrawerOpen = useMedspotStore((state) => state.setDrawerOpen);
  const alreadyRedirected = useRef<Record<string, boolean>>({});

  useEffect(() => {
    refreshUser("App");
    // if (window.localStorage.getItem("navigateToUrl")) {
    //   navigate(window.localStorage.getItem("navigateToUrl")!);
    //   setIsDrawerOpen(false);
    //   window.localStorage.removeItem("navigateToUrl");
    // }
    window.onNotificationResponseReceived = (responseStringified: string) => {
      const response: NotificationResponse = JSON.parse(responseStringified);
      const url = response.notification.request.content.data.url;
      if (url && !alreadyRedirected.current[response.notification.date]) {
        navigate(url);
        setIsDrawerOpen(false);
        alreadyRedirected.current[response.notification.date] = true;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <SentryRoutes>
        <Route path="health" element={<div>OK</div>} />
        <Route path="qrcode" element={<QRCode />} />
        <Route path="from_qrcode" element={<FromQRCode />} />
        <Route path="cgus" element={<CGUS />} />
        <Route path="confidentialité" element={<PrivacyPolicy />} />
        <Route path="welcome">
          <Route element={<Welcome />}>
            <Route index element={<WelcomeConnexion />} />
            <Route path="login-redirect" element={<WelcomeLoginRedirect />} />
            <Route path="login-profile" element={<WelcomeLoginProfile />} />
          </Route>
        </Route>
        <Route
          element={
            <RestrictedRoute id="app">
              <HomeLayout />
            </RestrictedRoute>
          }
        >
          <Route index element={<Feed />} />
          <Route path="stats" element={<Stats />} />
          <Route path="users" element={<Users />} />
          <Route path="post/:postId" element={<Post />} />
          <Route path="profile/:id" element={<Profile />} />
        </Route>
        {/* <Route path="app" element={<Outlet />}></Route> */}
      </SentryRoutes>
    </>
  );
}

function RestrictedRoute({
  children,
  id,
}: {
  children: ReactElement;
  id: string;
}) {
  const user = useMostFreshUser("RestrictedRoute " + id);
  const navigate = useNavigate();
  const location = useLocation();

  // console.log(id, 'restricted route user', user);

  useEffect(() => {
    if (!user?.id) {
      navigate("/welcome");
      return;
    }
    if (!isUserOnboarded(user) && !location.pathname.startsWith("/welcome")) {
      navigate("/welcome/login-profile");
      return;
    }
  }, [user, navigate, location]);

  if (!user?.id) {
    return <div>Chargement...</div>;
  }

  return children;
}

// function TestSentry() {
//   useEffect(() => {
//     capture("Test Sentry");
//   }, []);
//   return <div>Test Sentry</div>;
// }

export default App;
